/**
 * This is the email routes configuration.
 * Only configure routes in this file.
 * @memberOf email Module
 * @namespace email Routes
 */
import twofaEmailTemplate from './2fa.email.html';

/**
 * @name config
 * @desc Configures the routes.
 * @param $stateProvider
 * @memberOf email Module.email Routes
 * @ngInject
 */
var config = function ($stateProvider) {
	$stateProvider
		.state('login.2fa.email', {
			url: '/register/email',
			template: twofaEmailTemplate,
			controller: 'twofaEmailController',
			controllerAs: 'vm'
		});

	
}

export default config;


// WEBPACK FOOTER //
// ./src/login/2fa/email/2fa.email.route.js